import styled from 'styled-components';

import HomeSectionImage from '../../assets/home-section-background.jpeg';

import { slideLeft, slideRight } from './animations';

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1;
  width: 100vw;
  height: 100vh;
  font-family: 'Sora', sans-serif;
  color: ${({ theme }) => theme.colors.black};
  overflow: auto;
`;

export const Header = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #e2e8f0;
  padding: 0;
  background-color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0;
  position: relative;
  z-index: 11;

  nav {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 944px;
    padding: 1rem 1.5rem;
    align-items: center;

    img {
      height: 44px;
    }

    ul {
      display: flex;

      li {
        display: block;
        padding: 14px;

        a {
          color: ${({ theme }) => theme.colors.black};
          font-weight: 600;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      button {
        display: none;
        background-color: transparent;
        border: none;
        outline: none;
        color: #101d40;

        span {
          font-size: 30px;
        }
      }

      @media (max-width: 800px) {
        li {
          display: none;
        }

        button {
          display: block;
        }
      }
    }
  }
`;

export const HomeSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(${HomeSectionImage});
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;

  div.background {
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);
    height: 100vh;
    width: 100%;

    div.container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 45px;
      padding: 24px;
      margin: auto;

      @media (max-width: 800px) {
        grid-template-columns: 1fr;
        row-gap: 45px;
      }

      div.content {
        max-width: 475px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        h1 {
          font-size: 36px;
          padding-top: 70px;
          padding-bottom: 16px;
          font-weight: 400;
          color: #fff;

          strong {
            font-weight: 900;

            &:first-child {
              font-size: 90px;
            }
          }

          @media (max-width: 800px) {
            font-size: 28px;
            padding-top: 40px;
            text-align: center;

            strong {
              &:first-child {
                font-size: 68px;
              }
            }
          }
        }
      }

      div.form-container {
        display: flex;
        justify-content: center;
        max-width: 500px;

        div.form-content {
          height: auto;
          background-color: #fff;
          padding: 24px;
          border-radius: 6px;
          border: 1px #dcdcdc;
          color: #3e3e3e;
          box-shadow: 0 3px 10px rgb(29 26 26 / 20%);

          h2 {
            color: ${({ theme }) => theme.colors.black};
            font-size: 28px;
            font-weight: 700;
            margin-bottom: 5px;

            @media (max-width: 800px) {
              font-size: 24px;
            }
          }

          p {
            color: ${({ theme }) => theme.colors.grey};
            font-size: 16px;

            @media (max-width: 800px) {
              font-size: 14px;
            }
          }

          div.form {
            margin-top: 32px;

            button {
              width: 100%;
              height: 48px;
              font-size: 18px;
              font-weight: 600;
              border-radius: 5px;
              border: none;
              margin-top: 32px;
              background-color: #ed3237;
              color: #fff;
              font-family: 'Sora', sans-serif;
            }

            div.input-content {
              display: flex;
              flex-direction: column;
              gap: 5px;
              width: 100%;

              label {
                font-family: 'Sora', sans-serif;
                font-size: 16px;
                font-weight: 600;
                color: ${({ theme }) => theme.colors.black};
              }

              input:not([type='radio']),
              select {
                background-color: ${({ theme }) => theme.colors.white};
                border: 2px solid ${({ theme }) => theme.colors.lightGrey};
                border-radius: 5px;
                padding: 13px 15px;
                font-family: 'Sora', sans-serif;
                font-size: 13px;
                color: ${({ theme }) => theme.colors.black};
                width: 100%;
                transition: all 0.2s ease;
                height: 49px;

                &:focus {
                  border-color: #ed3237;
                }

                &.right {
                  border-top-right-radius: 0px;
                  border-bottom-right-radius: 0px;
                }

                &.left {
                  border-top-left-radius: 0px;
                  border-bottom-left-radius: 0px;
                }
              }

              & + div.input-content {
                margin-top: 20px;
              }
            }
          }
        }
      }
    }
  }
`;

export const VideoSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 70px 50px;

  @media (max-width: 800px) {
    padding: 290px 30px 50px;
  }

  h1 {
    color: ${({ theme }) => theme.colors.black};
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 44px;
    text-align: center;
  }

  div.why-atac-video {
    width: 90%;
    max-width: 944px;

    iframe {
      width: 100%;
    }
  }
`;

export const BenefitsSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f7f7f7;
  padding: 48px 50px 60px;
  width: 100%;

  @media (max-width: 800px) {
    padding: 48px 30px 30px;
  }

  h1 {
    color: ${({ theme }) => theme.colors.black};
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 50px;
    text-align: center;
  }

  div.benefits-list {
    div.benefit-item {
      display: flex;
      align-items: center;

      span {
        color: #ed3237;
        margin-right: 15px;
      }

      p {
        font-size: 16px;
        color: #404656;
      }

      & + div.benefit-item {
        margin-top: 20px;
      }
    }
  }
`;

export const SaleStepsSection = styled.section`
  display: flex;
  padding: 70px 50px;
  align-items: center;
  justify-content: center;

  @media (max-width: 800px) {
    padding: 50px 30px;
  }

  div.container {
    display: flex;
    align-items: center;
    max-width: 944px;

    @media (max-width: 800px) {
      flex-direction: column;
    }

    div.content {
      margin-left: 100px;

      @media (max-width: 800px) {
        margin: 0 0 100px;
        order: -1;
      }

      h1 {
        color: ${({ theme }) => theme.colors.black};
        font-size: 32px;
        font-weight: 700;
        margin-bottom: 32px;
        text-align: center;
      }

      ol.steps {
        list-style: none;

        li {
          font-size: 16px;
          color: #404656;

          span {
            font-weight: 700;
            margin-right: 5px;
          }

          & + li {
            margin-top: 15px;
          }
        }
      }
    }
  }
`;

export const BePartnerSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 70px 50px;

  @media (max-width: 1210px) {
    padding: 50px 30px;
  }

  div.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h1 {
      color: ${({ theme }) => theme.colors.black};
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 32px;
      text-align: center;

      @media (max-width: 1210px) {
        margin-bottom: 15px;
      }
    }

    a {
      padding: 12px 48px;
      font-size: 18px;
      font-weight: 600;
      border-radius: 5px;
      border: none;
      margin-top: 32px;
      background-color: #ed3237;
      color: #fff;
      font-family: 'Sora', sans-serif;
      text-decoration: none;
    }
  }
`;

export const DemoStoresSection = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 70px 50px;

  @media (max-width: 1210px) {
    padding: 50px 30px;
  }

  h1 {
    color: ${({ theme }) => theme.colors.black};
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 44px;
    text-align: center;
  }

  div.container {
    display: grid;
    grid-template-columns: 350px 350px 350px;
    column-gap: 30px;
    row-gap: 30px;

    div.xl {
      display: block;
    }

    div.carousel-root {
      display: none;
    }

    @media (max-width: 1210px) {
      width: 100%;
      display: block;

      div.carousel-root {
        display: block;
      }

      div.xl {
        display: none;
      }
    }

    div.demo-store {
      border: 2px solid #e6e6e9;
      border-radius: 5px;
      padding: 32px;

      img,
      video {
        width: 100%;
        margin-bottom: 10px;
      }

      div.content {
        text-align: center;

        h2 {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 20px;
        }

        p {
          font-size: 14px;
          margin-bottom: 20px;
        }

        a {
          display: block;
          padding: 12px 24px;
          font-size: 18px;
          font-weight: 600;
          border-radius: 5px;
          border: none;
          background-color: #ed3237;
          color: #fff;
          font-family: 'Sora', sans-serif;
          text-decoration: none;
        }
      }
    }
  }
`;

export const OurPlansSection = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 70px 50px;

  @media (max-width: 1210px) {
    padding: 50px 30px;
  }

  h1 {
    color: ${({ theme }) => theme.colors.black};
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 44px;
    text-align: center;
  }

  div.container {
    display: flex;
    align-items: center;
    justify-content: center;

    div.plans {
      display: grid;
      grid-template-columns: 350px 350px 350px;
      column-gap: 30px;
      row-gap: 30px;

      @media (max-width: 1210px) {
        grid-template-columns: 1fr;
      }

      div.plan {
        width: 100%;
        border: 2px solid #e6e6e9;
        border-radius: 5px;

        header {
          padding: 36px 36px 24px 36px;
          border-bottom: 1px solid #e6e6e9;

          h3 {
            font-size: 20px;
            margin-bottom: 24px;
          }

          > span {
            font-size: 14px;
            color: #7e7f90;
            font-weight: 400;
          }

          h2 {
            display: flex;
            align-items: center;
            font-size: 36px;
            margin-bottom: 24px;
            font-weight: 700;

            span {
              font-size: 16px;
              color: #7e7f90;
              margin-left: 8px;
              font-weight: 400;
            }
          }

          p {
            font-size: 16px;
            color: #7e7f90;
          }
        }

        main {
          padding: 24px 36px;

          ul.features {
            li {
              display: -webkit-box;
              position: relative;

              svg {
                float: left;
                margin-top: -2px;
                height: 24px;
                width: 24px;
              }

              p {
                clear: both;
                font-size: 16px;
                margin-left: 10px;
                line-height: 24px;

                &:hover + span {
                  display: block;
                }
              }

              > span {
                display: none;
                position: absolute;
                width: 100%;
                background-color: #101d40;
                padding: 12px;
                font-size: 13px;
                color: #fff;
                bottom: calc(100% + 10px);
                border-radius: 3px;
                transform: translateX(50%);
                left: -50%;

                &::after {
                  content: '';
                  position: absolute;
                  top: 100%;
                  left: 50%;
                  margin-left: -5px;
                  border-width: 5px;
                  border-style: solid;
                  border-color: rgb(16, 29, 64) transparent transparent;
                }
              }

              &.active {
                svg {
                  color: #36b37e;
                }

                p {
                  text-decoration: none;
                  color: #101d40;
                }
              }

              &.inactive {
                svg {
                  color: #7e7f90;
                }

                p {
                  text-decoration: line-through;
                  color: #7e7f90;
                }
              }

              &.help {
                p {
                  &::after {
                    content: '?';
                    margin-left: 5px;
                    background-color: #101d40;
                    border-radius: 50%;
                    font-size: 12px;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    padding: 0 4px;
                    line-height: 5px;
                  }
                }
              }

              & + li {
                margin-top: 20px;
              }
            }
          }
        }

        footer {
          padding: 24px 36px 36px;

          button {
            width: 100%;
            padding: 12px 48px;
            font-size: 18px;
            font-weight: 600;
            border-radius: 5px;
            border: none;
            border: 2px solid #e6e6e9;
            color: #101d40;
            background-color: transparent;
            font-family: 'Sora', sans-serif;
          }
        }
      }
    }
  }
`;

export const MobileMenu = styled.nav`
  position: absolute;
  height: 100vh;
  width: 80%;
  background-color: #fff;
  z-index: 9999999;
  padding: 1rem 1.5rem;
  box-shadow: 0 3px 10px rgb(29 26 26 / 20%);
  transform: translateX(-100%);

  img {
    height: 44px;
  }

  ul {
    margin-top: 40px;

    li {
      padding: 14px 0;

      a {
        color: ${({ theme }) => theme.colors.black};
        font-weight: 600;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  @media (max-width: 800px) {
    &.opened {
      transform: translateX(0%);
      animation: ${slideRight} 0.2s;
    }

    &.closed {
      transform: translateX(-100%);
      animation: ${slideLeft} 0.2s;
    }
  }
`;

export const WhatsappButton = styled.a`
  display: grid;
  place-items: center;
  right: 30px;
  width: 50px;
  bottom: 20px;
  height: 50px;
  padding: 5px;
  z-index: 200;
  overflow: hidden;
  position: fixed;
  background: rgb(77, 194, 71);
  box-shadow: rgb(0 0 0 / 40%) 2px 2px 6px;
  box-sizing: border-box;
  transition: all 0.5s ease 0s;
  border-radius: 50%;
  border: none;
  text-decoration: none;
  cursor: pointer;

  svg {
    color: #ffffff;
    font-size: 32px;
  }

  @media (max-width: 800px) {
    right: 20px;
    bottom: 20px;
  }
`;
